import React from 'react';
import errorMessages from '../constants/errorMessages';  
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '', errorDetails: null };
  }
  
  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    console.error(`error', 'onGetDerivedStateFromErrorError boundary caught an error . ErrorMessage : ${errorMessages.UNKNOWN_ERROR} . errorDetails : ${error}`);
    return { hasError: true, errorMessage: errorMessages.UNKNOWN_ERROR, errorDetails: error.toString() };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to aws cloud watch
    console.error('error', 'onComponentDidCatch : Error boundary caught an error', { error, errorInfo });
     this.setState({ errorDetails: errorInfo.componentStack });
  }

  handleRetry = () => {
    this.setState({ hasError: false, errorMessage: '', errorDetails: null });
    const { isAuthenticated } = useAuth();
    return isAuthenticated ? <Navigate to="/" replace /> : <Navigate to="/loginPage" replace/>
   };

  render() {
    if (this.state.hasError) {
      // Render a comprehensive fallback UI
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>{this.state.errorMessage}</h2>
          <p>نأسف لحدوث خطأ. يُرجى المحاولة مرة أخرى.</p>
          <pre style={{ color: 'red', whiteSpace: 'pre-wrap', textAlign: 'left' }}>
             
          </pre>
          <button onClick={this.handleRetry} style={{ marginRight: '10px' }}>الصفحة الرئيسية</button>
          <button onClick={() => window.location.reload()}>إعادة تحميل الصفحة</button>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
